export default { isEnabled: () => false, isHidden: true, name: 'stub' };
